module.exports = __webpack_public_path__ + "static/media/hero_home.1dec6317.png";